export const REPORT_EXPORT_ACTIVITIES = [
  ['order', 'Pedidos'],
  ['quote', 'Cotizaciones'],
  ['refund', 'Devoluciones'],
  ['charge', 'Cobros'],
  ['delivery', 'Entregas'],
  ['settlement', 'Liquidaciones'],
  ['pos_task_activity', 'Ejecución en punto de venta']
]
const ALL = REPORT_EXPORT_ACTIVITIES.map(([key]) => key)
const CONFIG = {
  summary: { name: 'actividades', tabName: 'resumen', workflows: ALL },
  orders: { name: 'pedidos y cotizaciones', tabName: 'pedidos', workflows: ['order', 'quote'] },
  refunds: { name: 'devoluciones', tabName: 'devoluciones', workflows: ['refund'] },
  charges: {
    name: 'cobros y liquidaciones',
    tabName: 'cobros',
    workflows: ['charge', 'settlement']
  },
  deliveries: {
    name: 'entregas y liquidaciones',
    tabName: 'entregas',
    workflows: ['delivery', 'settlement']
  },
  pos: {
    name: 'ejecución en punto de venta',
    tabName: 'ejecución en punto de venta',
    workflows: ['pos_task_activity']
  }
}
export const reportExportConfig = (tab) => CONFIG[tab] || CONFIG.summary
